<template>
  <div class="wx-biz-message-push-form">
    <AppScrollbar style="height: 100%">
      <div v-if="tplInfo.fields"
           class="form-wrap">
        <el-form size="mini"
                 label-width="100px"
                 label-suffix="：">
          <el-form-item v-for="(field, index) in tplInfo.fields"
                        :key="'field-' + index"
                        :label="field.keyword">
            <WxBizMessagePushFormInput v-model="field.value"
                                       :rule="field.rule"></WxBizMessagePushFormInput>
          </el-form-item>
        </el-form>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../../elements/AppScrollbar'
import WxBizMessagePushFormInput from './input'
export default {
  name: 'WxBizMessagePushForm',
  components: {
    AppScrollbar,
    WxBizMessagePushFormInput
  },
  props: {
    tplInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    getInput () {
      return new Promise((resolve, reject) => {
        const fields = this.tplInfo.fields || []
        const find = fields.find(field => !field.value)
        if (find) {
          reject(new Error(`请填写${find.keyword}`))
          return
        }
        let input = {}
        fields.forEach(field => {
          input[field.kid] = field.value
        })
        resolve(input)
      })
    }
  }
}
</script>

<style lang="scss">
  .wx-biz-message-push-form {
    height: 100%;
    background-color: #fff;
    .form-wrap {
      padding: 12px 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
            text-align: left;
          }
          .el-form-item__content {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
